function trimCategoryLabel(category: string): string {
    return category.trim();
}

export function readAnalyticsCategoryNamesFromSource(source: unknown): string[] | undefined {
    if (source == null || typeof source !== 'object') {
        return undefined;
    }

    const record = source as {
        c_analyticsCategoryNames?: unknown;
        categoryNames?: unknown;
    };

    const rawNames = Array.isArray(record.c_analyticsCategoryNames)
        ? record.c_analyticsCategoryNames
        : Array.isArray(record.categoryNames)
          ? record.categoryNames
          : undefined;

    if (!rawNames) {
        return undefined;
    }

    const seen = new Set<string>();
    const labels = rawNames
        .filter((value): value is string => typeof value === 'string')
        .map(trimCategoryLabel)
        .filter((value) => {
            if (!value || seen.has(value)) {
                return false;
            }
            seen.add(value);
            return true;
        });

    return labels.length > 0 ? labels.slice(0, 5) : undefined;
}
